export default __webpack_public_path__ + "static/media/filterHovered.db07ac96.svg";